import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    assignedContestList: [],
    companyDropdownList:[],
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const NewContestShortLinkSlice = createSlice({
    name: "AddContestShortLink",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        assignedContestList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        CompanyList: (state, action) => {
            const { companyList } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.totalCount = 0;
            state.companyList = companyList;
          },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
        
    }
})